<!-- OTP Code  -->
<div class="alert alert-info custom-otp">

    <form (click)="error = ''">
        <p class="text-muted-color text-center mb-3">
            <strong>Please enter the verification code sent to your email.</strong>
        </p>

        <!-- USERNAME -->
        <div class="input-group">
            <span class="input-group-addon">
                <i class="glyphicon glyphicon-user"></i>
            </span>

            <input name="otp-username" id="otp-username" type="text" class="form-control removeBackgroud" [value]="constantService.user.username" disabled />
        </div>

        <!-- OTP INPUT -->
        <div class="otp-wrapper">

            <p-inputotp [(ngModel)]="otpValue" name="otp" [length]="6">
                <ng-template let-token let-events="events" let-index="index">
                    <input name="otp" id="otp" type="text" [maxLength]="1" (input)="events.input($event)" inputmode="numeric"
                        (keydown)="events.keydown($event)" [value]="token || ''"
                        [disabled]="authenticationService.loading || (otpValue?.length || 0) < 6" class="custom-otp-input" />

                    @if(index === 3){    
                    <div class="px-1">
                        <i class="pi pi-minus"></i>
                    </div>
                    }
                </ng-template>
            </p-inputotp>
        </div>

            <!-- remember-device -->
            <div >
                <app-remember-device></app-remember-device>
            </div>

        <div class="mt-4">
            @if(!isExpired){
            <p class="otp-msg text-center">
                OTP expires in: {{ formatTime() }}
            </p>
            <button id ="verifyOtpButton" type="button" class="btn btn-md btn-primary btn-block defaultBtnColor" (click)="verifyOtp()"
                [disabled]="authenticationService.loading">
                Verify OTP
                @if(authenticationService.loading){
                <img alt="loader" style="text-align:center"
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                } </button>
            }

            @if(isExpired){
            <p class="otp-msg text-center text-danger">
                OTP expired
            </p>

            <button id ="resendOtpButton" type="button" class="btn btn-md btn-primary btn-block defaultBtnColor" (click)="resendOtp()"
                [disabled]="authenticationService.loading">
                Resend OTP

                @if(authenticationService.loading){
                <img alt="loader" style="text-align:center"
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                } </button>


            }
        </div>
    </form>

    @if(error){
    <div class="alert alert-danger">{{error}}</div>
    }
</div>